import { c as _c } from "react/compiler-runtime";
function AchraIsotype(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M17.7969 23.1062C22.465 23.0959 27.1362 24.8834 30.6978 28.4691C31.5348 29.3118 32.2731 30.216 32.9128 31.1674C33.2375 31.6503 33.022 32.2984 32.4863 32.5246L26.9418 34.8657C26.5325 35.0385 26.0617 34.9047 25.7732 34.5667C25.6005 34.3644 25.419 34.1672 25.2287 33.9754C24.4558 33.1975 23.5922 32.5667 22.6722 32.0834C21.1498 31.2835 19.4727 30.8869 17.7969 30.8933C16.1212 30.8869 14.4441 31.2835 12.9217 32.0834C12.0016 32.5667 11.138 33.1975 10.3653 33.9754C10.1748 34.1672 9.99328 34.3644 9.82062 34.5667C9.53208 34.9047 9.0613 35.0385 8.65203 34.8657L3.1075 32.5246C2.57182 32.2984 2.35639 31.6503 2.68102 31.1674C3.32071 30.216 4.05902 29.3118 4.89597 28.4691C8.45756 24.8834 13.1289 23.0959 17.7969 23.1062Z" />;
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M8.38375 5.77518C8.38375 10.2571 5.60055 14.0846 1.6793 15.6014C1.31367 15.7429 1.04724 16.0727 1.01693 16.4639L0.532248 22.7209C0.484816 23.3332 1.01619 23.8335 1.6169 23.7091C9.8944 21.9939 16.1185 14.6163 16.1185 5.77518C16.1185 4.39791 15.9674 3.05617 15.6811 1.76582C15.5569 1.20609 14.954 0.913765 14.4239 1.13066L8.91235 3.38552C8.48591 3.55999 8.24789 4.01248 8.30414 4.47023C8.35668 4.89778 8.38375 5.3333 8.38375 5.77518Z" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M27.616 5.77518C27.616 10.2571 30.3992 14.0846 34.3204 15.6014C34.6861 15.7429 34.9525 16.0727 34.9829 16.4639L35.4675 22.7209C35.5149 23.3332 34.9836 23.8335 34.3829 23.7091C26.1053 21.9939 19.8813 14.6163 19.8813 5.77518C19.8813 4.39791 20.0324 3.05617 20.3186 1.76582C20.4428 1.20609 21.0457 0.913765 21.5759 1.13066L27.0874 3.38552C27.5139 3.55999 27.7519 4.01248 27.6957 4.47023C27.6431 4.89778 27.616 5.3333 27.616 5.77518Z" />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== className) {
    t4 = <svg viewBox="0 0 36 36" fill="currentColor" className={className} aria-hidden={true}>{t1}{t2}{t3}</svg>;
    $[3] = className;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
export { AchraIsotype };